import React, { useEffect, useState } from 'react';
import ProjectContactsAddEdit from './ProjectContactsAddEdit.jsx';
import ProjectContactsListItem from './ProjectContactsListItem.jsx';
import IconAdd from '../../images/IconAdd.jsx';

const ProjectContacts = ({ contacts, setContacts }) => {
    const [addVisible, setAddVisible] = useState(false);
    const [initialLead, setInitialLead] = useState('');

    const handleAddOverlay = () => {
        setAddVisible(true);
    };

    const handleDelete = (id) => {
        setContacts(contacts.filter((contact) => contact.contact_id !== id && contact.tempId !== id));
    };

    useEffect(() => {
        if (initialLead !== '') {
            setContacts((prev) =>
                prev.map((contact) => (contact.contact_id !== initialLead ? { ...contact, is_lead: false } : contact))
            );
        }
    }, [initialLead, setContacts]);

    return (
        <div className='mb-10'>
            <div className='flex justify-between items-center pb-2 mb-2 border-b border-solid border-theme1-tanTransparent'>
                <div className='text-theme1-primary2 font-bold text-base'>Key people</div>
                <button type='button' className='flex items-center justify-center bg-none' onClick={handleAddOverlay}>
                    <IconAdd className='fill-theme1-title2 w-6 h-6' />
                </button>
            </div>

            {contacts.length > 0 && (
                <>
                    <ul>
                        {contacts.map((contact, index) => (
                            <ProjectContactsListItem
                                key={contact.contact_id ?? contact.tempId}
                                data={contact}
                                onDelete={handleDelete}
                            />
                        ))}
                    </ul>
                </>
            )}

            {addVisible && (
                <ProjectContactsAddEdit
                    addVisible={addVisible}
                    setAddVisible={setAddVisible}
                    contacts={contacts}
                    setContacts={setContacts}
                    initialLead={initialLead}
                    setInitialLead={setInitialLead}
                />
            )}
        </div>
    );
};

export default ProjectContacts;
